import { friendApis } from '@apis/friendApis';
import { useQuery } from '@tanstack/react-query';

export const useFriendInvitedList = () =>
  useQuery(['/friend/invited/'], () => friendApis.get('/friend/invited/', {}).then((r) => r[200]!));
